/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  function manageCollectionFilterButton() {
    const isMobile = window.innerWidth < 768;

    if(!isMobile) {
      return;
    }

    const filterButton = document.querySelector('.popout__toggle.popout__toggle--filters');
    const collectionProducts = document.querySelector('.collection__products');
    const footerSections = document.querySelector('.footer-sections');

    if (filterButton === null || collectionProducts === null) {
      return;
    }

    const isFooterInView = footerSections.getBoundingClientRect().top < window.innerHeight;
    const isCollectionProductsInView = (collectionProducts.getBoundingClientRect().top + 150) < window.innerHeight;
    const showFilterButton = isCollectionProductsInView && !isFooterInView;

    if(showFilterButton) {
      filterButton.classList.add('is-active');
    } else {
      filterButton.classList.remove('is-active');
    }
  }

  manageCollectionFilterButton();
  window.addEventListener('scroll', manageCollectionFilterButton);

  function registerInfiniteScrollLoadMoreButton() {
    const selectors = {
      loadMoreButton: ".js-load-more",
      totalPages: "[data-total-pages]",
      currentPage: "[data-current-page]",
      nextUrl: "[data-next-url]",
      loadMoreText: "[load-more-text]",
      loaderText: "[loader-text]",
      products: ".collection__products .grid-item.product-item:not(.product-grid-item-placeholder)",
      productGrid: "div[data-products-grid] .grid",
      currentProducts: ".current-products",
      totalProducts: ".total-products",
    };

    const hideClass = "hide";
    const loadMoreButton = document.querySelector(selectors.loadMoreButton);

    if (loadMoreButton == null) {
      return;
    }

    loadMoreButton.addEventListener("click", (e) => {
      const totalPagesValue = Number(document.querySelector(selectors.totalPages).value);
      let currentPage = document.querySelector(selectors.currentPage);
      let currentPageValue = parseInt(currentPage.value);
      let nextUrl = document.querySelector(selectors.nextUrl);

      loadMoreButton.setAttribute("disabled", true);

      const loadMoreText = loadMoreButton.querySelector(selectors.loadMoreText);
      const loaderText = loadMoreButton.querySelector(selectors.loaderText);

      loadMoreText.classList.add(hideClass);
      loaderText.classList.remove(hideClass);

      fetch(nextUrl.value)
        .then((response) => {
          return response.text();
        })
        .then((html) => {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          const products = doc.querySelectorAll(selectors.products);
          insertProducts(products);

          const newUrl = nextUrl.value;

          nextUrl.value = nextUrl.value.replace(
            `page=${currentPageValue + 1}`,
            `page=${currentPageValue + 2}`
          );
          currentPage.value = currentPageValue + 1;

          if (currentPage.value >= totalPagesValue) {
            loadMoreButton.classList.add(hideClass);

            const currentProducts = document.querySelector(selectors.currentProducts);
            const totalProducts = document.querySelector(selectors.totalProducts);
            currentProducts.innerHTML = totalProducts.innerHTML;
          }

          loadMoreButton.removeAttribute("disabled");
          loadMoreText.classList.remove(hideClass);
          loaderText.classList.add(hideClass);

          window.history.pushState({
            param: Shopify.queryParams
          }, document.title, newUrl);

          // initializeQuickAdd();
        })
        .catch((error) => {
          console.warn("Loading more products failed", error);
          loadMoreButton.classList.add(hideClass);
        });
    });
  }

  function insertProducts(products, before = false) {
    const selectors = {
      productGrid: "div[data-products-grid] .grid",
      currentProducts: ".current-products",
      productCard: ".grid-item.product-item:not(.product-grid-item-placeholder)"
    };

    const productGrid = document.querySelector(selectors.productGrid);

    products.forEach((product) => {
      if (before) {
        productGrid.prepend(product);
      } else {
        productGrid.appendChild(product);
      }
    });

    const currentProducts = document.querySelector(selectors.currentProducts);
    currentProducts.innerHTML = productGrid.querySelectorAll(selectors.productCard).length;
  }

  registerInfiniteScrollLoadMoreButton();

  function removeTargetBlankFromEmptyCartButton() {
    const button = document.querySelector('.rebuy-cart__flyout-empty-cart > p > a');
    if(button) {
      button.removeAttribute('target');
    }
  };

  function initRebuyCart() {
    document.addEventListener('rebuy:smartcart.ready', (event) => {
      adjustRebuyContent();
      runRebuyCode(event.detail.smartcart.cart);
      removeTargetBlankFromEmptyCartButton();
    });

    document.addEventListener('rebuy:cart.change', (event) => {
      const cart = event.detail.cart.cart;
      runRebuyCode(cart);

      const headerCartStatuses = document.querySelectorAll('.header__cart__status');
      if (headerCartStatuses && headerCartStatuses.length > 0) {
        headerCartStatuses.forEach(__ => __.textContent = cart.item_count);
      }

      validateJerseyBuilderLineItems(cart);
    });
  }

  function validateJerseyBuilderLineItems(cart) {
    const builderItems = cart.items.filter(_ => _.properties["_attribution"] != null);

    if (builderItems.length === 0) {
      return;
    }

    const mainItems = builderItems.filter(_ => _.properties["_attribution_type"] === "main");
    const invalidAddons = builderItems.filter(_ => _.properties["_attribution_type"] === "addon" && !mainItems.some(mainItem => mainItem.properties["_attribution"] === _.properties["_attribution"]));

    if (invalidAddons.length == 0) { 
      return;
    }

    const data = {
      updates: {}
    };

    invalidAddons.forEach(invalidAddon => {
      data.updates[invalidAddon.key] = 0;
    });

    fetch(theme.routes.cart_update_url, {
      method: 'post',
      headers: { 
        'Content-Type': 'application/json',
        Accept: 'application/json'
       },
      body: JSON.stringify(data),
    })
    .then((response) => {
      // OK
    });
  }

  function runRebuyCode(cart) {
    const rebuyFooter = document.querySelector('.rebuy-cart__flyout-footer');
  
    if (!rebuyFooter) {
      return;
    }
  
    const subtotalPrice = cart.items_subtotal_price;
    let deliveryPrice = 3900;
  
    // if (subtotalPrice > 69900) {
    //   deliveryPrice = 0;
    // }
  
    const footerDetails = document.createElement('div');
    footerDetails.classList.add('footer-details');
  
    const subtotalLine = document.createElement('div');
    subtotalLine.classList.add('footer-details__line');
  
    const subtotalLeft = document.createElement('div');
    subtotalLeft.textContent = `Subtotal (${cart.item_count} ${cart.item_count > 1 ? 'produkter' : 'produkt'})`;
  
    const subtotalRight = document.createElement('div');
    subtotalRight.textContent = formatMoney(subtotalPrice, 'kr {{ amount }}');
    subtotalLine.appendChild(subtotalLeft);
    subtotalLine.appendChild(subtotalRight);
  
    const deliveryLine = document.createElement('div');
    deliveryLine.classList.add('footer-details__line');
  
    const deliveryLeft = document.createElement('div');
  
    const existingEstimatedDelivery = document.querySelector('cart-drawer .estimated-delivery');
    if (existingEstimatedDelivery) {
      const estimatedDelivery = existingEstimatedDelivery.cloneNode(true);
      deliveryLeft.appendChild(estimatedDelivery);
    }
  
    const deliveryRight = document.createElement('div');
    deliveryRight.textContent = deliveryPrice > 0 ? formatMoney(3900, 'kr {{ amount }}') : "Gratis levering";
  
    deliveryLine.appendChild(deliveryLeft);
    deliveryLine.appendChild(deliveryRight);
  
    footerDetails.appendChild(subtotalLine);
    footerDetails.appendChild(deliveryLine);
  
    const existingFooterDetails = rebuyFooter.querySelector('.footer-details');
    if (existingFooterDetails) {
      existingFooterDetails.remove();
    }
  
    rebuyFooter.prepend(footerDetails);

    let counter = 0;

    const interval = setInterval(() => {
      if (counter >= 10) {
        clearInterval(interval);
      }

      updateTotalPrice(subtotalPrice, deliveryPrice);

      counter++;
    }, 50);
  }
  
  function updateTotalPrice(subtotalPrice, deliveryPrice) {
    const totalPriceEl = document.querySelector('.rebuy-cart__flyout-subtotal-amount');

    if (totalPriceEl) {
      const clonedTotalPriceEl = totalPriceEl.cloneNode(true);
      clonedTotalPriceEl.classList.remove('rebuy-cart__flyout-subtotal-amount');
      clonedTotalPriceEl.classList.add('rebuy-cart__flyout-subtotal-amount-new');

      const total = subtotalPrice + deliveryPrice;
      clonedTotalPriceEl.textContent = formatMoney(total, 'kr {{ amount }}');
      const subtotalEl = document.querySelector('.rebuy-cart__flyout-subtotal');

      const existingTotalPriceEl = document.querySelector('.rebuy-cart__flyout-subtotal-amount-new');
      if (existingTotalPriceEl) {
        existingTotalPriceEl.remove();
      }

      subtotalEl.appendChild(clonedTotalPriceEl);
    }
  }
  
  function adjustRebuyContent() {
    setTimeout(() => {
      const paymentIcons = document.querySelector('.cart__drawer__payment__icons');
      const belowCheckout = document.querySelector('.rebuy-cart div[data-app-target="below_checkout"]');
  
      if (belowCheckout && paymentIcons) {
        const existingPaymentIcons = belowCheckout.querySelector('.cart__drawer__payment__icons');
        if (existingPaymentIcons) {
          existingPaymentIcons.remove();
        }
  
        const clonedPaymentIcons = paymentIcons.cloneNode(true);
        belowCheckout.appendChild(clonedPaymentIcons);
      }
  
      const subtotalElement = document.querySelector('.rebuy-cart__flyout-subtotal');
      const originalInfoTextRebuy = document.querySelector('.cart__info__rebuy__wrapper');
  
      if (subtotalElement && originalInfoTextRebuy) {
        const clonedInfoTextRebuy = originalInfoTextRebuy.cloneNode(true);
  
        const flyoutFooter = document.querySelector('.rebuy-cart__flyout-footer');
        flyoutFooter.insertBefore(clonedInfoTextRebuy, subtotalElement);
      }
    }, 500);
  }
  
  initRebuyCart();

  const moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision = 2, thousands = '.', decimal = ',') {
      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
      const centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', '');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function manageBreakers() {
    const breakers = [...document.querySelectorAll('.product-item--breaker')];

    breakers.forEach((breaker) => {
      const gridCol2Or4 = breaker.classList.contains('grid-col-2') || breaker.classList.contains('grid-col-4');
      if (gridCol2Or4) {
        const rows = Number(breaker.getAttribute('data-grid-rows') || 1);
        const heightOfSiblingCard = document.querySelector('.collection__products product-card').offsetHeight;
        const breakerHeight = heightOfSiblingCard * rows;

        breaker.style.height = `${breakerHeight}px`;
      }
    });
  }

  manageBreakers();

  function updateLigaLoginButton() {
    const ligaLoginButton = document.querySelector('liga-login');

    if(ligaLoginButton) {
      const path = window.location.pathname;

      if(!path.includes('account') || 1 == 1) {
        const currentRedirectUri = ligaLoginButton.getAttribute('redirect_uri');
        ligaLoginButton.setAttribute('redirect_uri', `${currentRedirectUri}?return_to=${path}`);
      }
    }
  }

  updateLigaLoginButton();

  function savePageVisited() {
    // Save the current url to local storage
    const path = window.location.pathname + window.location.search;

    // If page contains "login-redirect", don't save the page
    if (path.includes('login-redirect')) {
      return;
    }

    const key = 'previous-page-visited';
    localStorage.setItem(key, path);
  }

  savePageVisited();

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

async function addPreviousCollectionProducts() {
  const selectors = {
    products: ".grid-item.product-item",
    productGrid: "div[data-products-grid] .grid",
  };

  const previousProductDivs = document.querySelectorAll('.js-collection-previous-products');
  const reversedPreviousProductDivs = Array.from(previousProductDivs);
  const previousProducts = [];

  const promises = reversedPreviousProductDivs.map(div => {
    const url = div.getAttribute('data-url');
    return fetch(url).then(response => response.text());
  });

  const responses = await Promise.all(promises);

  responses.forEach((html, index) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const products = doc.querySelectorAll(selectors.products);
    previousProducts.push(...products);
  });

  const productGrid = document.querySelector(selectors.productGrid);
  const placeholders = [...document.querySelectorAll('.product-grid-item-placeholder')];

  previousProducts.reverse().forEach((product, index) => {
    if (placeholders[index]) {
      placeholders[index].outerHTML = product.outerHTML;
    } else {
      productGrid.prepend(product);
    }
  });

  placeholders.slice(previousProducts.length).forEach(placeholder => placeholder.remove());
}

function initializeNewsletterForm() {
  const termsCheckboxes = document.querySelectorAll('#terms_one, #terms_two');
  const submitButton = document.querySelector('.newsletter-submit-button-custom');

  const toggleSubmitButtonState = () => {
    if (submitButton) {
      const allChecked = Array.from(termsCheckboxes).every(checkbox => checkbox.checked);
      submitButton.classList.toggle('submit-newsletter-enabled', allChecked);
    }
  };

  termsCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', toggleSubmitButtonState);
  });

  toggleSubmitButtonState();
}

initializeNewsletterForm();

(async function () {
  await addPreviousCollectionProducts();
})();